import { DownloadLinkPayload } from "domain/entities/activities.entities";
import { createAppAsyncThunk } from "domain/store.thunk";

export const setTechniqueFavorite = createAppAsyncThunk(
  "activities/setTechniqueFavorite",
  async (techniqueId: number, { extra: { activitiesGateway } }) => {
    return await activitiesGateway.setTechniqueFavorite(techniqueId);
  }
);

export const setSeanceFavorite = createAppAsyncThunk(
  "activities/setSeanceFavorite",
  async (seanceId: number, { extra: { activitiesGateway } }) => {
    return await activitiesGateway.setSeanceFavorite(seanceId);
  }
);

export const setTutorialFavorite = createAppAsyncThunk(
  "activities/setTutorialFavorite",
  async (tutorialId: number, { extra: { activitiesGateway } }) => {
    return await activitiesGateway.setTutorialFavorite(tutorialId);
  }
);

export const setVisualSupportFavorite = createAppAsyncThunk(
  "activities/setVisualSupportFavorite",
  async (supportId: number, { extra: { activitiesGateway } }) => {
    return await activitiesGateway.setVisualSupportFavorite(supportId);
  }
);

export const getFavoriteActivities = createAppAsyncThunk(
  "activities/getFavoriteActivities",
  async (_, { extra: { activitiesGateway } }) => {
    return await activitiesGateway.getFavoriteActivities();
  }
);

export const removeFavoriteActivity = createAppAsyncThunk(
  "activities/removeFavoriteActivity",
  async (id: number, { extra: { activitiesGateway } }) => {
    return await activitiesGateway.removeFavoriteActivity(id);
  }
);

export const getPremiumActivitiesCount = createAppAsyncThunk(
  "activities/getPremiumActivitiesCount",
  async (_, { extra: { activitiesGateway } }) => {
    return await activitiesGateway.getPremiumActivitiesCount();
  }
);

export const getDownloadLink = createAppAsyncThunk(
  "activities/getDownloadLink",
  async (body: DownloadLinkPayload, { extra: { activitiesGateway } }) => {
    return await activitiesGateway.getDownloadLink(body);
  }
);
